import isEmpty from './isEmpty'
import isNumber from './isNumber'
//=================================================================================
// calc base skill
//-----------------
export default function calcBaseSkill(character, skill) {
  // console.log('---------------------------------')
  // console.log('IN calcBaseSkill = ', skill.skill_name || skill.name)
  // ------
  // VARS
  // ------
  let base
  //
  const operatorMap = {
    '+': (a, b) => Number(a) + Number(b),
    '-': (a, b) => Number(a) - Number(b),
    '*': (a, b) => Number(a) * Number(b),
    '/': (a, b) => Number(a) / Number(b),
  }
  //=================================================================================
  // INTERNAL FUNCTION: get_characteristic
  // --------------------------------------
  function _get_characteristic(character, arg) {
    // console.log('======= _get_characteristic arg = ', arg)
    let char
    // ------------------
    // where numeric arg
    // ------------------
    if (isNumber(arg)) {
      char = arg
    }
    // -------------------------
    // where characteristic arg
    // -------------------------
    else {
      // normalise characteristic key (e.g. 'Pow' -> 'pow_cur')
      const key = String(arg).toLowerCase() + '_cur'
      char = character[key]
    }
    return char
  }
  //=================================================================================
  // INTERNAL FUNCTION: get_base
  // ----------------------------
  function _get_base(character, args) {
    // console.log('======= _get_base arg = ', args)
    // ------------------------------------
    // A. where arg1 <op1> arg2 <op2> arg3
    // ------------------------------------
    if (!isEmpty(args.formula_oper2)) {
      //
      const op1 = args.formula_oper1
      const op2 = args.formula_oper2

      // console.log('SCENARIO 1...')
      // console.log('op1 = ', op1)
      // console.log('op2 = ', op2)
      // console.log('formula_arg1 = ', args.formula_arg1)
      // console.log('formula_arg2 = ', args.formula_arg2)
      // console.log('formula_arg3 = ', args.formula_arg3)

      if (operatorMap[op1] && operatorMap[op2]) {
        //
        const arg1 = _get_characteristic(character, args.formula_arg1)
        const arg2 = _get_characteristic(character, args.formula_arg2)
        const arg3 = _get_characteristic(character, args.formula_arg3)

        // console.log('arg1 = ', arg1)
        // console.log('arg2 = ', arg2)
        // console.log('arg3 = ', arg3)

        const base1 = operatorMap[op1](arg1, arg2)
        // console.log('base1 = ', base1)
        base = operatorMap[op2](base1, arg3)
        // console.log('base = ', base)
      } else {
        alert('Invalid operators in formula: ' + args.formula_oper1 + ' or ' + args.formula_oper2)
      }
      // -------------------------
      // B. where arg1 <op1> arg2
      // -------------------------
    } else if (!isEmpty(args.formula_oper1)) {
      //
      const op1 = args.formula_oper1

      // console.log('SCENARIO 2...')
      // console.log('op1 = ', op1)
      // console.log('formula_arg1 = ', args.formula_arg1)
      // console.log('formula_arg2 = ', args.formula_arg2)

      if (operatorMap[op1]) {
        //
        const arg1 = _get_characteristic(character, args.formula_arg1)
        const arg2 = _get_characteristic(character, args.formula_arg2)
        //
        base = operatorMap[op1](arg1, arg2)
      } else {
        alert('Invalid operator in formula: ' + args.formula_oper1)
      }
      // -------------
      // C. where arg1
      // --------------
    } else {
      // console.log('SCENARIO 3...')
      // console.log('formula_arg1 = ', args.formula_arg1)
      base = _get_characteristic(character, args.formula_arg1)
    }
    return base
  }
  //=================================================================================
  // MAIN: calcBaseSkill
  // --------------------
  let base_parm = []
  // ------------------------
  // load skill formula args
  // ------------------------
  if (skill.parent_name) {
    // console.log('PARENT SKILL....')
    // -------------------------------
    // load parent skill formula args
    // -------------------------------
    base_parm = {
      formula_arg1: skill.parent_formula_arg1,
      formula_arg2: skill.parent_formula_arg2,
      formula_arg3: skill.parent_formula_arg3,
      formula_oper1: skill.parent_formula_oper1,
      formula_oper2: skill.parent_formula_oper2,
    }
  } else {
    // console.log('STD SKILL....')
    base_parm = {
      formula_arg1: skill.formula_arg1,
      formula_arg2: skill.formula_arg2,
      formula_arg3: skill.formula_arg3,
      formula_oper1: skill.formula_oper1,
      formula_oper2: skill.formula_oper2,
    }
  }
  // -----------------------------------------------------------------
  // Fallback: derive formula args from `skill.formula` when arg fields
  // are empty (e.g. legacy data where only `formula` was populated).
  // Supports simple patterns like "Pow+Int" or "Str-Int".
  // -----------------------------------------------------------------
  if (isEmpty(base_parm.formula_arg1) && !isEmpty(skill.formula)) {
    const raw = String(skill.formula).replace(/\s+/g, '')
    const m = raw.match(/^([A-Za-z0-9]+)([+\-*/])([A-Za-z0-9]+)$/)
    if (m) {
      base_parm.formula_arg1 = m[1].toLowerCase()
      base_parm.formula_arg2 = m[3].toLowerCase()
      base_parm.formula_oper1 = m[2]
      base_parm.formula_arg3 = null
      base_parm.formula_oper2 = null
    }
  }
  // ---------------------
  // get base skill value
  // ---------------------
  return _get_base(character, base_parm)
}
